import yup from "../../../../../../validation/yup";
import {MAX_BIO_LENGTH} from "./constants";
import {REQUIRED_MESSAGE} from "../Step1/constants";

export const validationSchema = yup.object().shape({
    bio: yup.string()
        .max(MAX_BIO_LENGTH)
        .required(REQUIRED_MESSAGE),
})